<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="'80%'" [nzVisible]="isVisible"
  [nzTitle]=" data ? 'Edit Event' : 'Create New Event'" [nzFooter]="footerTpl" (nzOnClose)="closeonly()"
  [nzSize]="'default'">


  <div *nzDrawerContent>
    <nz-spin [nzSpinning]="loading" [nzTip]="loadingMsg | async">
      <form *ngIf="eventForm" [formGroup]="eventForm" (ngSubmit)="onSubmit()" nz-form [nzLayout]="'vertical'">

        <div nz-row [nzGutter]="24">
          <div nz-col [nzSpan]="10">


            <nz-form-item>
              <nz-form-control>
                <nz-spin [nzSpinning]="loadingImage" nzTip="Loading Event Image...">
                  <div class="event-image-wrapper">
                    <img *ngIf="eventImageUrl" [src]="eventImageUrl" alt="Event Image" class="event-image" />
                    <div *ngIf="!eventImageUrl" class="event-image-placeholder">No Image Selected</div>

                    <button nz-button nzType="default" class="upload-button" type="button" (click)="imageInput.click()">
                      <nz-icon nzType="upload" nzTheme="outline" /> Upload
                    </button>

                    <input #imageInput type="file" (change)="onImageChange($event)" accept="image/*" hidden />
                  </div>
                </nz-spin>
              </nz-form-control>
            </nz-form-item>



            <h3><nz-icon nzType="calendar" nzTheme="outline" />
              {{ eventForm?.value?.event_name || 'A new event' }}
            </h3>
            <nz-divider></nz-divider>

            <!-- Event URL -->
            <p>
              <span class="event-create-icon"><nz-icon nzType="link" nzTheme="outline" /></span>
              {{ eventForm?.value?.event_url || 'No URL provided' }}
            </p>

            <!-- Event Type -->
            <p>
              <span class="event-create-icon"><nz-icon nzType="tag" nzTheme="outline" /></span>
              @if (eventForm?.value?.event_type) {
              <nz-tag>{{ getEventTypeName(eventForm?.value?.event_type) }}</nz-tag>
              } @else {
              No event type selected
              }
            </p>

            <!-- Event Status -->
            <p>
              <span class="event-create-icon"><nz-icon nzType="check-circle" nzTheme="outline" /></span>
              @if (eventForm?.value?.status) {
              <nz-tag>{{ getEventStatusName(eventForm?.value?.status) }}</nz-tag>
              } @else {
              No event status selected
              }
            </p>

            <!-- Project -->
            <p>
              <span class="event-create-icon"><nz-icon nzType="project" nzTheme="outline" /></span>
              @if (eventForm?.value?.project || data?.project_details?.name) {
              <nz-tag>{{ getProjectName(eventForm?.value?.project) || data?.project_details?.name }}</nz-tag>
              } @else {
              No project selected
              }
            </p>


            <!-- Attendees -->
            <p>
              <span class="event-create-icon"><nz-icon nzType="team" nzTheme="outline" /></span>
              {{ eventForm?.value?.number_of_attendees || '0' }} attendees
            </p>

            <!-- Location -->
            <p>
              <span class="event-create-icon"><nz-icon nzType="global" nzTheme="outline" /></span>
              @if (eventForm?.value?.event_format === 2) {
              {{ getFormattedCountryNames() || 'No country specified' }}
              } @else if (eventForm?.value?.city || eventForm?.value?.state || eventForm?.value?.country) {
              {{ getLocationString() }}
              @if (eventForm?.value?.event_format === 3 && getFormattedCountryNames()) {
              | {{ getFormattedCountryNames() }}
              }
              } @else {
              No location specified
              }
            </p>

            <!-- Date & Time -->
            <!-- <p>
  <span class="event-create-icon"><nz-icon nzType="clock-circle" nzTheme="outline" /></span>
  @if (eventForm?.value?.start_datetime && eventForm?.value?.end_datetime) {
    {{ getFormattedDateTime() }}
  } @else {
    No date/time specified
  }
</p> -->

            <!-- Budget -->
            <!-- <p>
  <span class="event-create-icon" style="margin-left: 2px;font-size:16px;margin: right 16pxpx">
    @if (eventForm?.value?.budget_currency_type) {
      {{ getCurrenyName(eventForm?.value?.budget_currency_type) }}
    }
  </span>

  @if (eventForm?.value?.budget_type === 'FREE') {
    Free event
  } @else if ( eventForm?.value?.budget_currency_type) {
    {{ eventForm?.value?.budget_currency_amount }}
    @if (eventForm?.value?.budget_type === 'PER_PERSON') {
      (per person)
    }
  } @else {
    Budget not specified
  }
</p> -->



          </div>

          <div nz-col [nzSpan]="14">


            <nz-steps [nzCurrent]="stepIndex" style="margin-bottom: 20px;" (nzIndexChange)="onIndexChange($event)">
              <nz-step nzTitle="Event Info"></nz-step>
              <nz-step nzTitle="Location"></nz-step>
              <nz-step nzTitle="Budget"></nz-step>
              <nz-step nzTitle="Assign Event"></nz-step>
            </nz-steps>


            @if(stepIndex == 0){
            <nz-form-item>
              <nz-form-label nzFor="eventName" nzRequired>Event Name</nz-form-label>
              <nz-form-control nzErrorTip="Event name is required">
                <input nz-input formControlName="event_name" id="eventName" placeholder="Enter event name" />
              </nz-form-control>
            </nz-form-item>



            <nz-form-item>
              <nz-form-label nzFor="eventUrl">Event URL</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="event_url" id="eventUrl" placeholder="https://example.com/event"
                  type="url" />
              </nz-form-control>
            </nz-form-item>


            <nz-form-item>
              <nz-form-label nzFor="eventFormat" nzRequired>Event Format</nz-form-label>
              <nz-form-control nzErrorTip="Event format is required">
                <nz-radio-group formControlName="event_format" id="eventFormat">
                  <label nz-radio *ngFor="let format of eventFormats" [nzValue]="format.id">
                    {{ format.name }}
                  </label>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>


            <nz-form-item>
              <nz-form-label nzFor="eventType" nzRequired>Event Type</nz-form-label>
              <nz-form-control nzErrorTip="Event type is required">
                <nz-select formControlName="event_type" id="eventType" nzPlaceHolder="Select event type">
                  <nz-option *ngFor="let type of eventTypes" [nzValue]="type.id" [nzLabel]="type.name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>


            <nz-form-item>
              <nz-form-label nzFor="status" nzRequired>Event Status</nz-form-label>
              <nz-form-control nzErrorTip="Event status is required">
                <nz-select formControlName="status" id="status" nzPlaceHolder="Select event status">
                  <nz-option *ngFor="let type of statusList" [nzValue]="type.id" [nzLabel]="type.name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>


            <nz-form-item>
              <nz-form-label nzFor="industry">Client Industries Focus</nz-form-label>
              <nz-form-control nzErrorTip="Please select industries">
                <nz-select id="industry" nzPlaceHolder="Select industry" nzAllowClear nzShowSearch nzServerSearch
                  formControlName="industry" (nzOnSearch)="onSearchIndustry($event)" [nzMode]="'multiple'">
                  @if (!loadingIndustries) {
                  @for (industry of listOfIndustries; track industry.id) {
                  <nz-option [nzValue]="industry.id" [nzLabel]="industry.name"></nz-option>
                  }
                  } @else {
                  <nz-option nzDisabled nzCustomContent>
                    <nz-icon nzType="loading" class="loading-icon" />
                    Loading Data...
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>



            <nz-form-item>
              <nz-form-label nzFor="project">Project</nz-form-label>
              <nz-form-control nzErrorTip="Please select at least one project">
                <nz-select [nzDisabled]="disabledProject" id="project" nzPlaceHolder="Select Projects" nzAllowClear
                  nzShowSearch nzServerSearch formControlName="project" (nzOnSearch)="onSearchProject($event)">
                  @if (!loadingProject) {
                  @for (project of listOfProject; track project.id) {
                  <nz-option [nzValue]="project.id" [nzLabel]="project.name"></nz-option>
                  }
                  } @else {
                  <nz-option nzDisabled nzCustomContent>
                    <nz-icon nzType="loading" class="loading-icon" />
                    Loading Data...
                  </nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>


            <nz-form-item>
              <nz-form-label nzFor="attendees" nzRequired>Number of Attendees</nz-form-label>
              <nz-form-control nzErrorTip="Enter a whole number">
                <input nz-input type="number" formControlName="number_of_attendees" id="attendees" min="1" step="1"
                  (keydown)="blockDecimalInput($event)" (input)="sanitizeAttendeesInput($event)" />
              </nz-form-control>
            </nz-form-item>
            }


            @if(stepIndex == 1){


            <!-- <nz-form-item>
          <nz-form-label>Country</nz-form-label>
          <nz-form-control    >
            <nz-select nzShowSearch formControlName="country" id="country" nzPlaceHolder="Country">
              @for (country of countryList; track country.id) {
                <nz-option   [nzValue]="country.id" [nzLabel]="`${country.name}`"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item> -->


            <!-- <nz-form-item>
          <nz-form-label>State</nz-form-label>
          <nz-form-control    >
            <nz-select nzShowSearch formControlName="state" id="state" nzServerSearch  (nzOnSearch)="onSearchState($event)" nzPlaceHolder="state">
              @for (state of stateList; track state.id) {
                <nz-option   [nzValue]="state.id" [nzLabel]="`${state.name}`"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item> -->




            <!-- Location Field: Show only for In-Person (1) or Hybrid (3) -->
            <nz-form-item *ngIf="eventForm.value.event_format === 1 || eventForm.value.event_format === 3">
              <nz-form-label>Location</nz-form-label>
              <nz-form-control>
                <nz-select nzShowSearch nzAllowClear formControlName="city" id="state" nzServerSearch
                  (nzOnSearch)="onSearchCity($event)" (ngModelChange)="onCitySelect($event)"
                  nzPlaceHolder="Search and select location">
                  @for (city of cityList; track city.id) {
                  <nz-option [nzValue]="city.id"
                    [nzLabel]="`${city.name}, ${city.state_name}, ${city.country_name}`"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <!-- Country Field: Show only for Virtual (2) or Hybrid (3) -->
            <nz-form-item *ngIf="eventForm.value.event_format === 2 || eventForm.value.event_format === 3">
              <nz-form-label>Country</nz-form-label>
              <nz-form-control>
                <nz-select nzShowSearch nzAllowClear formControlName="country" id="country"
                  nzPlaceHolder="Select Country" [nzMode]="'multiple'">
                  @for (country of countryList; track country.id) {
                  <nz-option [nzValue]="country.id" [nzLabel]="country.name"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>


            <nz-form-item>
              <nz-form-label nzFor="eventDuration" nzRequired>Event Duration</nz-form-label>
              <nz-form-control nzErrorTip="Event duration is required">
                <nz-radio-group formControlName="duration" id="eventDuration">
                  <label nz-radio *ngFor="let d of durationList" [nzValue]="d.id"
                    [nzDisabled]="(d.id === 1 || d.id === 2) && (event_days.controls.length > 1)">
                    {{ d.name }}
                    <!-- Show help icon when other options are disabled (i.e., multi-day only allowed) -->
                    <ng-container
                      *ngIf="d.id === 3 && eventForm.get('duration')?.value === 3 && (event_days.controls.length > 1)">
                      <i nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                        [nzTooltipTitle]="'To select Half-day or Single-day, please delete extra event day rows.'"
                        style="margin-left:6px; color:#8c8c8c;"></i>
                    </ng-container>
                  </label>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>



            <div class="event-days-table-container" formArrayName="event_days"
              style="border:1px solid #d9d9d9;border-radius:6px;">
              <nz-table [nzData]="event_days.controls" [nzFrontPagination]="false" [nzShowPagination]="false"
                [nzBordered]="true" [nzSize]="'middle'" class="event-days-table">
                <thead>
                  <tr>
                    <th *ngIf="eventForm.get('duration')?.value === 3" style="width: 10%"></th>
                    <th nzRequired>Event Date</th>
                    <!-- Move Day Type next to Event Date for Multi-day -->
                    <th *ngIf="eventForm.get('duration')?.value === 3" nzRequired style="width: 20%">Day Type</th>
                    <th nzRequired>Start Time</th>
                    <th nzRequired>End Time</th>
                    <!-- Keep Day Type at original place for Half/Single -->
                    <th *ngIf="eventForm.get('duration')?.value !== 3" nzRequired style="width: 20%">Day Type</th>
                    <th *ngIf="eventForm.get('duration')?.value === 3" style="width: 10%">Action</th>
                  </tr>
                </thead>

                @for (dayGroup of event_days.controls; track dayGroup; let i = $index; let last = $last) {
                <tr [formGroupName]="i">
                  <td *ngIf="eventForm.get('duration')?.value === 3" class="day-label-cell"
                    style="height: 37px !important;">
                    <span> Day {{ i + 1 }}</span>
                  </td>

                  <td style="padding:8px;">
                    <nz-form-item><nz-form-control>
                        <nz-date-picker formControlName="event_date" [nzFormat]="'MM-dd-yyyy'"
                          [nzDisabledDate]="getDisabledDateForRow(i)" style="width: 100%;">
                        </nz-date-picker>
                      </nz-form-control></nz-form-item>
                  </td>

                  <!-- Day Type cell right after Event Date for Multi-day -->
                  <td *ngIf="eventForm.get('duration')?.value === 3" style="padding:8px;">
                    <nz-form-item><nz-form-control>
                        <nz-select formControlName="day_type" style="width: 100%;">
                          <nz-option nzValue="full" nzLabel="Full Day"></nz-option>
                          <nz-option nzValue="half" nzLabel="Half Day"></nz-option>
                          <nz-option nzValue="roundtable" nzLabel="Roundtable"></nz-option>
                        </nz-select>
                      </nz-form-control></nz-form-item>
                  </td>

                  <td style="padding:8px;">
                    <nz-form-item><nz-form-control>
                        <nz-time-picker formControlName="start_time" style="width: 100%;" [nzUse12Hours]="true"
                          [nzFormat]="'hh:mm a'" [nzMinuteStep]="15" nzHideDisabledOptions>
                        </nz-time-picker>
                      </nz-form-control></nz-form-item>
                  </td>

                  <td style="padding:8px;">
                    <nz-form-item><nz-form-control>
                        <nz-time-picker formControlName="end_time" style="width: 100%;" [nzUse12Hours]="true"
                          [nzFormat]="'hh:mm a'" [nzMinuteStep]="15" nzHideDisabledOptions>
                        </nz-time-picker>
                      </nz-form-control></nz-form-item>
                  </td>

                  <!-- Keep Day Type at original spot for Half/Single -->
                  <td *ngIf="eventForm.get('duration')?.value !== 3" style="padding:8px;">
                    <nz-form-item><nz-form-control>
                        <nz-select formControlName="day_type" style="width: 100%;">
                          <nz-option nzValue="full" nzLabel="Full Day"></nz-option>
                          <nz-option nzValue="half" nzLabel="Half Day"></nz-option>
                          <nz-option nzValue="roundtable" nzLabel="Roundtable"></nz-option>
                        </nz-select>
                      </nz-form-control></nz-form-item>
                  </td>

                  <td *ngIf="eventForm.get('duration')?.value === 3" class="action-cell"
                    style="display:flex;justify-content:center;align-items: center;padding: 12px;">
                    @if (event_days.controls.length > 1) {
                    <button type="button" nz-button nzDanger [nzSize]="'small'" (click)="removeEventDay(i)"
                      title="Remove Day">
                      <i nz-icon nzType="minus-circle" nzTheme="outline"></i>
                    </button>
                    }
                  </td>
                </tr>
                }
              </nz-table>
            </div>

            <!-- Global Add button for Multi-day mode -->
            <div *ngIf="eventForm.get('duration')?.value === 3" class="dateAddBtn">
              <button type="button" nz-button nzType="primary" [nzSize]="'small'" (click)="addEventDay()"
                [disabled]="!event_days.valid" title="Add Day">
                <i nz-icon nzType="plus" nzTheme="outline"></i> Add
              </button>
            </div>


            <nz-form-item style="margin-top:25px;">
              <nz-form-label>Timezone</nz-form-label>
              <nz-form-control>
                <nz-select nzShowSearch nzAllowClear nzServerSearch (nzOnSearch)="onSearchTimezone($event)"
                  formControlName="time_zone" id="state" nzPlaceHolder="Time zone">
                  @for (zone of timezones; track zone.id) {
                  <nz-option [nzValue]="zone.id" [nzLabel]="`${zone.name} (${zone.offset})`"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            }



            @if(stepIndex == 2){


            <nz-form-item>
              <nz-form-label nzRequired nzFor="budgetType">Budget</nz-form-label>
              <nz-form-control nzErrorTip="Budget type is required">
                <nz-select formControlName="budget_type" id="budgetType" nzPlaceHolder="Select budget type">
                  <nz-option *ngFor="let type of budgetType" [nzValue]="type.code" [nzLabel]="type.name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>



            <div *ngIf="eventForm.value.budget_type !== 'FREE'" class="grid grid-cols-1 md:grid-cols-2 gap-4">

              <nz-form-item>
                <nz-form-label nzRequired nzFor="currency">Currency</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="budget_currency_type" id="currency" nzErrorTip="Currency is required"
                    (ngModelChange)="onCurrencyChange($event)" nzPlaceHolder="Select currency">
                    <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id"
                      [nzLabel]="currency.symbol"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>



              <nz-form-item>
                <nz-form-label nzRequired nzFor="budget_currency_amount">Amount</nz-form-label>
                <nz-form-control nzErrorTip="Amount is required">
                  <input nz-input type="number" name="budget_currency_amount" (ngModelChange)="calculateAmount($event)"
                    formControlName="budget_currency_amount" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label nzFor="usd_currency_exchange_rate"> Exchange Rate</nz-form-label>
                <nz-form-control nzErrorTip="Exchange rate is required">
                  <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
                    <input nz-input type="number" name="usd_currency_exchange_rate"
                      formControlName="usd_currency_exchange_rate" (ngModelChange)="calculateAmount($event)" />
                  </nz-input-group>
                  <ng-template #addOnAfterTemplate>
                    <button nz-button nzType="text" class="converter" (click)="fetchConvertion($event)">
                      <nz-icon nzType="reload" [nzSpin]="loadingConversion" nzTheme="outline" />
                    </button>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label nzFor="amount">Amount (USD)</nz-form-label>
                <nz-form-control>
                  <input nz-input type="number" min="0" formControlName="budget_amount" id="amount" [disabled]="true" />
                </nz-form-control>
              </nz-form-item>
            </div>


            }






            @if(stepIndex == 3){

            <!-- 1. Assigned Group -->
            <nz-form-item>
              <nz-form-label nzFor="assignedGroup">Assigned Group</nz-form-label>
              <nz-form-control>
                <nz-select nzShowSearch nzAllowClear formControlName="assigned_group" nzPlaceHolder="Select a group">
                  @for(user of groups; track user.id) {
                  <nz-option [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <!-- 2. BEC Event Planner -->
            <nz-form-item>
              <nz-form-label nzFor="bec_event_planner">BEC Event Planner</nz-form-label>
              <nz-form-control>
                <nz-select nzAllowClear nzShowSearch nzServerSearch [nzMode]="'multiple'"
                  (nzOnSearch)="onSearchMember($event)" formControlName="bec_event_planner"
                  nzPlaceHolder="Select a team member">
                  @for (person of teamMembers; track person.id) {
                  <nz-option [nzValue]="person.id" [nzLabel]="`${person.name}`"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <!-- 3. Event Manager -->
            <nz-form-item>
              <nz-form-label nzFor="assignedTo" nzRequired>Event Manager</nz-form-label>
              <nz-form-control>
                <nz-select nzAllowClear nzShowSearch nzServerSearch [nzMode]="'multiple'"
                  (nzOnSearch)="onSearchMember($event)" formControlName="assigned_to"
                  nzPlaceHolder="Select a team member">
                  @for (person of teamMembers; track person.id) {
                  <nz-option [nzValue]="person.id" [nzLabel]="`${person.name}`"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <!-- 4. On-Site Event Manager -->
            <nz-form-item>
              <nz-form-label nzFor="event_manager">On-Site Event Manager</nz-form-label>
              <nz-form-control>
                <nz-select nzAllowClear nzShowSearch nzServerSearch [nzMode]="'multiple'"
                  (nzOnSearch)="onSearchManager($event)" formControlName="event_manager"
                  nzPlaceHolder="Select a event manager">
                  @for (person of teamMembers; track person.id) {
                  <nz-option [nzValue]="person.id" [nzLabel]="`${person.name}`"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            }

              <!-- 5. External Moderators -->
              @if(stepIndex == 3){
              <nz-form-item>
                <nz-form-label nzFor="event_moderators">External Moderators</nz-form-label>
                <nz-form-control>
                  <div style="display: flex; gap: 8px; align-items: flex-start;">
                    <nz-select nzAllowClear nzShowSearch [nzMode]="'multiple'"
                      formControlName="event_moderators"
                      nzPlaceHolder="Select moderators"
                      style="flex: 1;">
                      @for (mod of allModerators; track mod.id) {
                      <nz-option [nzValue]="mod.id"
                        [nzLabel]="mod.name + (mod.company ? ' - ' + mod.company : '')"></nz-option>
                      }
                    </nz-select>
                    <button type="button" nz-button nzType="dashed" (click)="openModeratorModalForDrawer()">
                      <nz-icon nzType="plus"></nz-icon> Add Moderator
                    </button>
                  </div>
                </nz-form-control>
              </nz-form-item>
              }







          </div>
        </div>



        <!-- Submit Button -->
        <!-- <div class="text-right pt-4">
    <button nz-button nzType="primary" htmlType="submit">
      {{ data ? 'Update' : 'Create' }}
    </button>
  </div> -->



      </form>
    </nz-spin>
  </div>


  <ng-template #footerTpl>
    <div style="float: right">
      <button nz-button style="margin-right: 8px;" (click)="closeonly()">Cancel</button>

      <!-- Next visible until Budget (steps 0,1,2) -->
      <button *ngIf="stepIndex < 3" nz-button style="margin-right: 8px;" nzType="primary" (click)="nextStep()">
        Next
      </button>

      <!-- Create/Update only on last step (Assign Event - stepIndex 3) and disabled until valid -->
      <button *ngIf="stepIndex === 3" nz-button nzType="primary" [disabled]="!canSubmit" (click)="onSubmit()">
        {{ data ? 'Update' : 'Create' }}
      </button>
    </div>
  </ng-template>

</nz-drawer>

<!-- <app-loader *ngIf="loading"></app-loader> -->

<!-- External Moderator Modal -->
<app-moderator-modal
  [(visible)]="moderatorModalVisible"
  [moderator]="editingModeratorForDrawer"
  [allModerators]="allModerators"
  [linkedModeratorIds]="linkedModeratorIdsForDrawer"
  [allowExistingSelect]="true"
  [saving]="moderatorSaving"
  (save)="onModeratorSaveForDrawer($event)"
  (cancel)="closeModeratorModalForDrawer()">
</app-moderator-modal>